import isEmpty from 'lodash/isEmpty';
import isString from 'lodash/isString';
import { track } from 'src/client/js/analytics/facade';

const trackLinkFactory = (config={}) => event => {
  if (isEmpty(config)) {
    return;
  }
  let target = config.href || (event.target && event.target.href);
  if (isString(target) && target.startsWith('#')) {
    // ignore anchors
    target = null;
  }
  if (target) {
    event.preventDefault();
  }
  track(config.action, {
    category: config.category,
    label: config.label,
    value: config.value,
  }).then(() => {
    if (target) {
      window.top.location = target;
    }
  });
};

export default trackLinkFactory;



// WEBPACK FOOTER //
// ./src/client/js/analytics/factory/link.js